import { Box, Divider } from '@mui/material';
import type { BackupJob } from '@repo/api-gw-sdk';

import { PanelWrapper } from '@/components/panels/panelWrapper';

import {
  backupJobItemFields,
  backupJobSummaryFromFields,
  backupJobSummaryToFields,
} from './backupJobItemFields';
import { JobItemFields } from './jobItemFields';
import { JobStatusCard } from './jobStatusCard';
import { OperationSummary } from './operationSummary';

export const BackupJobsCard = ({
  job,
  onClose,
}: {
  job: BackupJob;
  onClose: () => void;
}) => {
  return (
    <PanelWrapper
      header={{
        title: 'Job details',
        onClose,
        hideBorder: true,
      }}
      testIdPrefix='backup-jobs-card'
    >
      <BackupJobsCardContent job={job} />
    </PanelWrapper>
  );
};

const BackupJobsCardContent = ({ job }: { job: BackupJob }) => {
  const fromCloudProvider = job.resourceDetails?.cloudProvider;
  const toCloudProvider = job.vault?.cloudProvider;

  return (
    <Box className='pb-[40px]' overflow='auto'>
      <JobItemFields job={job} fields={backupJobItemFields} />
      <Divider />
      <JobStatusCard job={job} />
      <OperationSummary
        job={job}
        fromTitle='Backup from'
        fromFields={backupJobSummaryFromFields}
        fromCloudProvider={fromCloudProvider}
        toTitle='Backup to'
        toFields={backupJobSummaryToFields}
        toCloudProvider={toCloudProvider}
      />
    </Box>
  );
};
